import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import desktopImage from '../../../assets/images/backoffice/akasha/akasha.png';
// import mobileImage from '../../../assets/images/backoffice/akasha/akashaMobile.png';
import desktopAkashaImage from '../../../assets/images/backoffice/akasha/akashaPageBanner.png';
import mobileAkashaImage from '../../../assets/images/backoffice/akasha/akashaPageBannerMobile.png';
import { AnimatedDashboard } from '../../../components/animation/AnimatedDashboard';
import Spinner from '../../../components/common/Spinner';
import { getUserTickets } from '../../../slices/auth-slice';
import { P1 } from '../../../styles/FontStyles';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';
import { Desktop, Mobile } from '../../Kyc/KycStyled';
import { getAkashaHubs } from '../Marketplace.actions';
import styled from 'styled-components';
import { useHistory } from 'react-router';

import { USDT, formatUSDNoDecimals } from '../../../helpers/helperFunctions';

import { PurchasePackageAndCombo } from '../PurchasePackageAndCombo/PurchasePackageAndCombo';

export const AkashaSuperNodeButton = styled(Button)`
  color: ${({ theme }) => theme.colors.neutral900};
  background: #01f1c1;
  font-size: 18px;
  font-weight: bold;
  height: 50px;
  border-radius: 20px;
  margin-top: 56px;
`;

import {
  // Tab,
  AkashaGrid,
  GridItem,
  AkashaTitle,
  PackagesTitle,
  Separator,
  AkashaFirstHub,
  AkashaPackageH2
} from './Akasha.styled';

import { MY_HUBS_AKASHA } from '../../../routes/routes';

export const Akasha = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { loading, hubs } = useSelector((state) => state.marketplace);

  const firstHub = [hubs[0]];

  useEffect(() => {
    dispatch(getAkashaHubs());
    dispatch(getUserTickets());
  }, [dispatch]);

  const [selectedHub, setSelectedHub] = useState(hubs?.[0] || null);
  const [modal, setModal] = useState(false);

  const handleSeeDetails = (hub) => {
    setSelectedHub(hub);
  };

  const handleSelectPackage = (hub) => {
    setModal(true);
    handleSeeDetails(hub);
  };

  const renderAkashaBanner = () => {
    return (
      <>
        <Desktop>
          <section style={{ position: 'relative' }}>
            <img
              src={desktopAkashaImage}
              alt='trading'
              style={{ width: '100%' }}
            />
          </section>
        </Desktop>

        <Mobile>
          <section style={{ position: 'relative' }}>
            <img
              src={mobileAkashaImage}
              alt='trading'
              style={{ width: '100%' }}
            />
          </section>
        </Mobile>
      </>
    );
  };
  useEffect(() => {
    setSelectedHub(hubs?.[0]);
  }, [hubs]);

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'marketplace'}>
      {renderAkashaBanner()}
      <AkashaTitle>
        Own the Future of DeFi — Super Nodes Available Now!
      </AkashaTitle>

      <P1 mb='40' mt='20'>
        {' '}
        The revolution has begun. The world’s most powerful Layer 0 blockchain
        is here and now is your chance to secure a Super Node. Become a
        foundational part of a next-gen decentralized ecosystem—engineered for
        massive scalability, seamless cross-chain connectivity, and real-world
        utility that’s redefining DeFi.Don’t just watch the future unfold—
        <b>own a piece of it.</b>
      </P1>

      <AkashaTitle>
        Discover the Advantages of Becoming a Super Node Holder
      </AkashaTitle>
      <P1 bold mt='10' color='#2074A8'>
        Earn Daily Rewards
      </P1>
      <P1 mb='30'>
        Generate passive income every day by participating in blockchain
        validation and ecosystem growth.
      </P1>

      <P1 bold mt='10' color='#2074A8'>
        Priority Access to Ecosystem Projects
      </P1>
      <P1 mb='30'>
        Get early access to upcoming launches, token drops, and DeFi
        opportunities within the Layer 0 ecosystem.
      </P1>

      <P1 bold mt='10' color='#2074A8'>
        Locked-In Power Position
      </P1>
      <P1 mb='30'>
        Secure a fixed, long-term position in the network’s foundation with
        priority in future expansion and utilities.
      </P1>

      <P1 bold mt='10' color='#2074A8'>
        Cross-Chain Yield Potential
      </P1>
      <P1 mb='30'>
        Tap into rewards across multiple blockchains as the Layer 0 platform
        bridges the DeFi universe.
      </P1>

      <P1 bold mt='10' color='#2074A8'>
        Limited Availability
      </P1>
      <P1 mb='30'>
        Super Nodes are scarce and exclusive—once they’re sold out, access is
        closed to the public.
      </P1>

      <AkashaSuperNodeButton
        selected={true}
        maxWidth='250px'
        maxWidthSM='100%'
        onClick={() => history.push(MY_HUBS_AKASHA)}>
        Manage Super Nodes
      </AkashaSuperNodeButton>

      <PackagesTitle>Super Nodes Packages</PackagesTitle>
      <Flexed center justifyCenter mb='32'>
        {firstHub.map((hub, index) => (
          <AkashaFirstHub
            selected={selectedHub?.id === hub?.id}
            onClick={() => handleSeeDetails(hub)}
            key={index}>
            <Flexed width='350px' widthSM='100%' flexNone>
              <img src={hub?.image} style={{ width: '100%' }} />
            </Flexed>
            <Flexed column ml='30' mlSM='0' width='100%'>
              <Flexed column center>
                <AkashaPackageH2 mb='4' mtSM='30'>
                  {hub?.name}
                </AkashaPackageH2>
              </Flexed>
              <P1 color={'#2074A8'} bold>
                {formatUSDNoDecimals(hub?.price)} {USDT}
              </P1>
              <Separator />
              <Flexed between>
                <P1 mb='12' bold>
                  Node ON
                </P1>
                <P1 color={colors.neutral500} bold>
                  {hub?.nodeOnPercentage}%
                </P1>
              </Flexed>

              <Flexed between>
                <P1 mb='12' bold>
                  Node OFF
                </P1>
                <P1 color={colors.neutral500} bold>
                  {hub?.nodeOffPercentage}%
                </P1>
              </Flexed>
              <Button
                color='#0CAACD'
                borderColor='#0CAACD'
                // background='#2074A8'
                wSM='100%'
                mt='20'
                onClick={() => handleSelectPackage(hub)}
                negative={true}>
                Select Super Node
              </Button>
            </Flexed>
          </AkashaFirstHub>
        ))}
      </Flexed>

      <AkashaGrid>
        {hubs.slice(1).map((hub, index) => (
          <GridItem
            key={index}
            selected={selectedHub?.id === hub?.id}
            onClick={() => handleSeeDetails(hub)}>
            <img src={hub.image} style={{ width: '100%' }} />

            <Flexed column center>
              <AkashaPackageH2 mb='4' mt='30'>
                {hub.name}
              </AkashaPackageH2>
            </Flexed>
            <P1 mb='12' color={'#2074A8'} bold>
              {formatUSDNoDecimals(hub.price)} {USDT}
            </P1>
            <Separator />

            <Flexed between>
              <P1 mb='12' bold>
                Node ON
              </P1>
              <P1 color={colors.neutral500} bold>
                {hub.nodeOnPercentage}%
              </P1>
            </Flexed>

            <Flexed between>
              <P1 mb='12' bold>
                Node OFF
              </P1>
              <P1 color={colors.neutral500} bold>
                {hub.nodeOffPercentage}%
              </P1>
            </Flexed>
            <Button
              color='#0CAACD'
              borderColor='#0CAACD'
              w='200px'
              wSM='100%'
              mt='20'
              onClick={() => handleSelectPackage(hub)}
              negative={true}>
              Select Super Node
            </Button>
          </GridItem>
        ))}
      </AkashaGrid>

      <PurchasePackageAndCombo
        selectedPackage={selectedHub}
        modal={modal}
        setModal={setModal}
      />
    </AnimatedDashboard>
  );
};
